import { Grid } from '@mui/material'
import React, { useImperativeHandle, useRef, useState } from 'react';
import { UploadButton } from '../../buttons'
import Input from '../text-field-input';

interface UploadInputProps {
    text?: string;
    loading?: boolean;
    disabled?: boolean;
    errorText?: string;
    options: {
        accept?: string;
        multiple?: boolean;
        onChange: (files: FileList | []) => void;
    }
}

const getFileNames = (files: FileList) => {
    const fileNames = [];
    for (let i = 0; i < files.length; i++) {
        fileNames.push(files[i].name);
    }
    return fileNames.join(',');
}

const UploadInput = React.forwardRef((props: UploadInputProps, ref: any) => {

    const { text, loading, disabled, errorText, options } = props;

    const [fileName, setFileName] = useState<string>('');
    const uploadInputRef = useRef<any>(null);

    const handleUploadButton = (e: any) => {
        const files: FileList = e.target.files;
        if (files.length > 0) {
            const names = getFileNames(files);
            setFileName(names);
            options.onChange(files);
        } else {
            handleClear();
        }
    }

    const handleClear = () => {
        setFileName('');
        options.onChange([]);
        uploadInputRef.current.handleClearInput();
    }

    useImperativeHandle(ref, () => ({
        handleClear
    }));

    return (
        <Grid container spacing={2}>
            <Grid item flexGrow={1}>
                <Input
                    id="fileName"
                    name="fileName"
                    caption="Dosya Adı"
                    className="mr-1"
                    disabled
                    readOnly
                    value={fileName}
                    errorText={errorText}
                />
            </Grid>
            <Grid item>
                <UploadButton
                    ref={uploadInputRef}
                    text={text}
                    disabled={disabled}
                    loading={loading}
                    options={{
                        accept: options.accept,
                        onChange: handleUploadButton,
                        multiple: options.multiple
                    }}
                />
            </Grid>
        </Grid>
    )
});

export default UploadInput